import { useState } from 'react';
import { navLinks } from '@/mocks/blackliao';

export default function TopBar() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  return (
    <div
      className="sticky top-0 z-50 w-full transition-colors duration-200 border-b border-background-200"
      style={{ backgroundColor: 'var(--color-shell, #fbf9f4)' }}
    >
      <div className="w-full">
        <div className="mx-auto max-w-[1440px] px-4 md:px-6">
          {/* top meta strip */}
          <div className="hidden lg:flex items-center justify-between h-9 text-[12px] text-foreground-600 border-b border-background-200">
            <div className="flex items-center gap-2">
              <i className="ri-broadcast-line text-primary-500 text-sm"></i>
              <span className="truncate max-w-[520px]">全网吃瓜第一现场 · 新黑料网热帖与围观动态实时滚动，理性吃瓜不传谣</span>
            </div>
            <div className="flex items-center gap-4 whitespace-nowrap">
              <a href="#watch" className="flex items-center gap-1 hover:text-primary-600"><i className="ri-eye-line"></i>围观现场</a>
              <a href="#comments" className="flex items-center gap-1 hover:text-primary-600"><i className="ri-community-line"></i>新黑料网社区</a>
              <span className="flex items-center gap-1 text-primary-600"><i className="ri-login-box-line"></i>投稿登录</span>
            </div>
          </div>

          {/* main bar */}
          <div className="flex items-center justify-between gap-4 py-3 md:py-4">
            <a href="#top" className="flex items-center gap-2.5 shrink-0">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
                <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-accent-400 ring-2 ring-background-50"></span>
              </span>
              <span className="leading-none">
                <span className="block text-lg md:text-xl font-black tracking-tight text-foreground-950">新黑料网</span>
                <span className="block mt-0.5 text-[10px] text-foreground-500 tracking-widest">围观 · 讨论 · 社区</span>
              </span>
            </a>

            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.key}
                  href={`#${l.key}`}
                  className="rounded-md px-3 py-2 text-[14px] font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
                >
                  {l.label}
                </a>
              ))}
            </nav>

            <div className="hidden lg:flex items-center gap-2 flex-1 justify-end">
              <div className="flex items-center w-full max-w-xs rounded-md bg-background-100 border border-background-200 px-3 h-9">
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜热帖 / 事件 / 分区"
                  className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400 text-foreground-800"
                />
                <i className="ri-search-line text-foreground-400 cursor-pointer hover:text-primary-600"></i>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="whitespace-nowrap h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors flex items-center gap-1.5 cursor-pointer"
              >
                <i className="ri-quill-pen-line"></i>发帖投稿
              </button>
            </div>

            <button
              className="md:hidden flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
              onClick={() => setOpen(!open)}
              aria-label="菜单"
            >
              <i className={open ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
            </button>
          </div>
        </div>

        {/* mobile menu */}
        {open && (
          <div className="md:hidden border-t border-background-200 bg-background-50">
            <div className="px-4 py-3 space-y-1">
              {navLinks.map((l) => (
                <a
                  key={l.key}
                  href={`#${l.key}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-primary-50"
                >
                  {l.label}<i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              ))}
              <button className="mt-2 w-full whitespace-nowrap h-10 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 cursor-pointer flex items-center justify-center gap-1.5">
                <i className="ri-quill-pen-line"></i>发帖投稿
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}